import React from 'react';

function BillingIndex(props) {
    return (
        <div></div>
    );
}

export default BillingIndex;
